import numeral from 'numeral';

// ----------------------------------------------------------------------

// Currency symbol mapping
export const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  CHF: 'CHF',
  CAD: 'CA$',
  AUD: 'A$',
  PLN: 'zł',
  ATS: '₹',
};

/**
 * Get currency symbol from currency code
 * @param {string} currencyCode - The currency code (e.g., 'USD', 'EUR')
 * @returns {string} The currency symbol
 */
export function getCurrencySymbol (currencyCode = 'USD') {
  return CURRENCY_SYMBOLS[currencyCode] || '$';
}

/**
 * Get length unit symbol from unit system
 * @param {string} lengthUnits - The unit system ('metric' or 'imperial')
 * @returns {string} The length unit symbol ('cm' for metric, 'in' for imperial)
 */
export function getLengthUnitSymbol (lengthUnits = 'imperial') {
  return lengthUnits === 'metric' ? 'cm' : 'in';
}

/**
 * Get weight unit symbol from unit string.
 * Supports specific units (lb, oz, kg, g) and legacy system identifiers (metric, imperial).
 * @param {string} weightUnits - The unit ('lb', 'oz', 'kg', 'g', 'metric', or 'imperial')
 * @returns {string} The weight unit symbol
 */
export function getWeightUnitSymbol (weightUnits = 'lb') {
  const legacy = { metric: 'kg', imperial: 'lb' };
  return legacy[weightUnits] || weightUnits;
}

export function fNumber (number) {
  return numeral(number).format();
}

export function fCurrency (number, currencyCode = 'USD') {
  const symbol = getCurrencySymbol(currencyCode);

  if (!number) return '';

  // Format the number first, then prepend the symbol
  const formatted = numeral(number).format('0,0.00');
  const cleanFormatted = result(formatted, '.00');

  return `${symbol}${cleanFormatted}`;
}

export function fPercent (number) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber (number) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData (number) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result (format, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}
